import styled from 'styled-components';

const ActionsWrapper = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 4em;

    // between elements only
    > * + * {
        margin-left: 1em;
    }
`;

export default ActionsWrapper;
